import { render, staticRenderFns } from "./NewGsCalendarItem.vue?vue&type=template&id=3193092a&scoped=true"
import script from "./NewGsCalendarItem.vue?vue&type=script&lang=js"
export * from "./NewGsCalendarItem.vue?vue&type=script&lang=js"
import style0 from "./NewGsCalendarItem.vue?vue&type=style&index=0&id=3193092a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3193092a",
  null
  
)

export default component.exports